export default __webpack_public_path__ + "static/media/webhook.5e7b78da.svg";